import { Card, CardContent } from '@material-ui/core'
import React from 'react'
import Background from 'assets/images/HR-Background.jpg'

export const EInvoiceBuyerDetailExpired = () => {
  return (
    <>
      <div
        className='einv-layout-completed'
        style={{
          background: 'url("' + Background + '") no-repeat center center fixed'
        }}
      >
        <div className='form-box' style={{ marginTop: '120px' }}>
          <span
            style={{
              fontFamily: 'Poppins, sans-serif',
              color: "#FFFFFF",
              fontWeight: 700,
              fontSize: '15px',
              display: 'flex', 
              justifyContent: 'center',
              alignItems: 'center',
              padding: '5px 0',
              marginBottom: '4px'
            }}
          >
            Expired
          </span>
          <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '2px'}}>
            <Card
              style={{
                margin: '5px 0',
                borderRadius: '5px', 
                width: '90%'
              }}
            >
              <CardContent>
                <span
                  style={{
                    fontFamily: 'Poppins, sans-serif',
                    color: "#000000",
                    fontWeight: 700,
                    fontSize: '14px',
                    display: 'flex', 
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '1px',
                    marginTop: '5px'
                  }}
                >
                  This QR code has expired. Please scan again to continue!
                </span>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  )
}